import React, { useState, useEffect } from 'react';
import LogoutButton from './LogoutButton';
import axios from 'axios';

const Alldata = () => {
    const [Formdata, setFormData] = useState([]); // Main table data
    const [ProTanyaData, setProTanyaData] = useState([]); // Pro_tanya table data
    const [searchQuery, setSearchQuery] = useState('');

    // Fetch data from the main table
    useEffect(() => {
        axios.get('https://st.tjdstore.in/api/get_data.php')
            .then(response => setFormData(response.data))
            .catch(error => console.error('Error fetching main data:', error));
    }, []);

    // Fetch Product_Quantity from Pro_tanya table (Quantity 2)
    useEffect(() => {
        axios.get('https://st.tjdstore.in/api/tanya_data.php')
            .then(response => setProTanyaData(response.data))
            .catch(error => console.error('Error fetching Pro_tanya data:', error));
    }, []);

    // Merge Quantity 2 into the main table data
    const mergedData = Formdata.map((product, index) => {
        const quantity2 = ProTanyaData[index]?.Product_Quantity || 'N/A'; // Match rows by index
        return {
            ...product,
            Quantity_2: quantity2, // Add Quantity 2
        };
    });

    const getQuantityClass = (quantity) => {
        const qty = Number(quantity);
        if (qty === 0) {
            return 'bg-danger boldtx';
        } else if (qty <= 3) {
            return 'bg-warning boldtx';
        } else {
            return 'bg-success boldtx';
        }
    };

    const filteredData = mergedData.filter((product) => {
        const lowerCaseQuery = searchQuery.toLowerCase();
        return (
            product.Product_Name?.toLowerCase().includes(lowerCaseQuery) ||
            product.Product_Size?.toLowerCase().includes(lowerCaseQuery) ||
            product.Product_Type?.toLowerCase().includes(lowerCaseQuery) ||
            product.Product_ID?.toLowerCase().includes(lowerCaseQuery) ||
            product.Product_SKU?.toLowerCase().includes(lowerCaseQuery)
        );
    });

    return (
        <div className="col-md-12">
            <div className="fixpanel">
            <h4 className="center">All Product</h4>
            <LogoutButton />
            {/* Search Input */}
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by any field..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} // Update search query on input change
                />
            </div>
            </div>
            <div className='clearfix'><br /></div>
            <div className="tabular">
            <table className='table custumt'>
                <thead>
                    <tr>
                        <th>SR. No</th>
                        <th>Name</th>
                        <th>Size</th>
                        <th>Quantity</th>
                        <th>Stock For Tanya</th> {/* New column for Quantity 2 */}
                        <th>Category</th>
                        <th>Product ID</th>
                        <th>SKU</th>
                        <th>Product Image</th>
                    </tr>
                </thead>
                <tbody>
                    {(searchQuery ? filteredData : mergedData).map((product, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{product.Product_Name}</td>
                            <td>{product.Product_Size}</td>
                            <td className={getQuantityClass(product.Product_Quantity)}>
                                {product.Product_Quantity}
                            </td>
                            <td>
                                {product.Quantity_2}
                            </td>
                            <td>{product.Product_Type}</td>
                            <td>{product.Product_ID}</td>
                            <td>{product.Product_SKU}</td>
                            <td>
                                <img
                                    src={product.Product_Img}
                                    alt={product.Product_Name}
                                    style={{ width: '100px', height: 'auto' }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {filteredData.length === 0 && searchQuery && (
                <div className="text-center">No results found for "{searchQuery}".</div>
            )}
            </div>
        </div>
    );
};

export default Alldata;
